import { Component, OnInit } from '@angular/core';
import { BaseComponent } from '../../../base-components/base.component';

@Component({
    selector: 'right-nav-bar',
    templateUrl: './right-nav-bar.component.html'
})
export class RightNavBarComponent extends BaseComponent implements OnInit {
    public helpVisible = false;

    constructor() {
        super();
    }

    ngOnInit() {
        this.helpCommunicationService.helpLinkClicked$.subscribe((x) => {
            this.toggleHelpPanelVisibility(true);
        });

        this.helpCommunicationService.closePanelClicked$.subscribe((x) => {
            this.toggleHelpPanelVisibility(false);
        });
    }

    navHelpIconClicked() {
        this.toggleHelpPanelVisibility(true);
        this.helpCommunicationService.emitPageLevelHelpClickEvent();
    }

    toggleHelpPanelVisibility(state: boolean) {
        this.helpVisible = state;
    }
}
